import { FACEBOOK, LINKEDIN, TWITTER } from '@/lib/socialProfile';

const useFormatSocialProfilesNetwork = () => {
    const formatSocialProfiles = (network) => {
        switch (network) {
            case FACEBOOK:
                return 'FB';
            case TWITTER:
                return 'TW';
            case LINKEDIN:
                return 'LN';
            default:
                return 'IG';
        }
    };

    return { formatSocialProfiles };
};

export default useFormatSocialProfilesNetwork;
